import React, { PropTypes } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { converDateIntoLocal } from "Constants";

class DetailsInfoUserItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resetpassword: false,
      loading: false,
      allowingaccess: false,
      selectedUsers: [],
      showEmailPreviewModal: false,
    };
  }

  render() {
    return (
      <tr key={this.props.appUser.Username} id={this.props.appUser.Username}>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 20, paddingTop: 3 }}
          >
            <div className="vcenter">{this.props.session.eventname}</div>
          </div>
        </td>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
          >
            <div className="vcenter">{this.props.appUser.Username}</div>
          </div>
        </td>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
          >
            <div className="vcenter ">
              {converDateIntoLocal(this.props.appUser.Activedate)}
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

export default connect(mapStateToProps, {})(DetailsInfoUserItem);
